import number from './number';

export default function unit(value, type, decimals = 0) {
  return value !== null && value !== undefined && value !== ''
    ? `${number(value, decimals)} ${type}`
    : '';
}
